export default __webpack_public_path__ + "static/media/Johnny Libenzon- Advisor.580b5714.jpg";